// extracted by mini-css-extract-plugin
export default {"main":"User_main__ISwRe","body-wrapper":"User_body-wrapper__Pvyle","action":"User_action__U66re"};